import type { Placement } from '@floating-ui/react-dom';
import { styled } from '@linaria/react';
import { useRef } from 'react';

import { Popover } from '~components/Popover';
import QuestionMarkIcon from '~public/assets/icons/question-mark.svg';

const Button = styled.button`
	line-height: 0;
`;

const Icon = styled(QuestionMarkIcon as React.ComponentType)`
	color: var(--color-grey-52-solid);

	&:hover {
		color: var(--color-white-solid);
	}
`;

const TooltipBox = styled.div`
	width: 300px;
`;

type Props = {
	children?: React.ReactNode;
	placement?: Placement;
	onClick?: () => void;
	onShow?: () => void;
};

export const TooltipButton = ({
	children,
	placement = 'top-end',
	onClick,
	onShow,
}: Props) => {
	const buttonRef = useRef<HTMLButtonElement>(null);

	return (
		<>
			<Button type="button" ref={buttonRef} onClick={onClick}>
				<Icon />
			</Button>

			{children && (
				<Popover placement={placement} ref={buttonRef} onShow={onShow}>
					<TooltipBox>{children}</TooltipBox>
				</Popover>
			)}
		</>
	);
};
